import dayjs from "dayjs"
import { useEffect } from "react"
import { usePageLifecycleContext } from "src/contexts/PageLifecycleContext"
import { usePolyglot } from "src/contexts/PolyglotContext"
import { useAccount } from "src/hooks/account/useAccount"
import { useUpdateAccount } from "src/hooks/account/useUpdateAccount"
import { PageLifecycle } from "src/types"

export function AccountContext() {
  const { data: account } = useAccount()
  const updateAccount = useUpdateAccount()
  const pageLifecycle = usePageLifecycleContext()
  const polyglot = usePolyglot()

  const isVisible = (
    pageLifecycle === PageLifecycle.Active ||
    pageLifecycle === PageLifecycle.Passive
  )

  useEffect(
    () => {
      if (!account || !updateAccount || !isVisible) {
        return
      }

      // the timezone offset in hours diff from UTC
      const timezoneOffset = dayjs().utcOffset() / 60
      const language = polyglot.locale()

      if (
        timezoneOffset !== Number(account.timezone) ||
        (language && language !== account.language)
      ) {
        void updateAccount({
          timezone: `${timezoneOffset}`,
          id: account.id,
          language,
        })
      }
    },
    [
      isVisible,
      account,
      updateAccount,
      polyglot,
    ],
  )

  return null
}
